module.exports = __webpack_public_path__ + "img/31_7.6f6b9f37.png";